<template>
    <div>
        <div style="text-align: center">
            <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                    id="btn-radios-2"
                    v-model="isAssignment"
                    :options="options"
                    :aria-describedby="ariaDescribedby"
                    button-variant="outline-primary"
                    name="radio-btn-outline"
                    buttons
                ></b-form-radio-group>
            </b-form-group>
        </div>

        <div style="text-align: right">
            <b-button size="sm" variant="primary" @click="$emit('view-item')"
                >Add Item</b-button
            >
        </div>
        <b-table striped hover :items="orderItems" :fields="fields" responsive>
            <template #cell(id)="data">
                <b-button
                    size="sm"
                    variant="primary"
                    @click="$emit('view-item', data.value)"
                    >Select</b-button
                >
                <b-button
                    size="sm"
                    @click="deleteItem(data.value)"
                    v-if="user_permissions.includes('delete.order.items')"
                    class="ml-2"
                    variant="warning"
                >
                    Delete
                </b-button>
            </template>

            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>

            <template #cell(order_item_type_id)="data">
                {{ data.value | displayTypeName(itemTypes) }}
            </template>

            <template #cell(details)="data">
                <span v-if="!!data.item.description">
                    {{ data.item.description }}
                </span>
                <ul class="dashed">
                    <li v-if="data.item.section_from_id">
                        <b>BIN Fr: </b>
                        {{
                            data.item.section_from_id
                                | displayWarehouseSection(warehouse_sections)
                        }}
                    </li>
                    <li v-if="data.item.section_to_id">
                        <b>BIN To: </b>
                        {{
                            data.item.section_to_id
                                | displayWarehouseSection(warehouse_sections)
                        }}
                    </li>
                    <li
                        v-if="data.item.assets.length"
                        v-html="displayAssets(data.item.assets)"
                    ></li>
                </ul>
            </template>

            <template #cell(price)="data">
                <p class="text-right">
                    {{ data.value | currency }}
                </p>
            </template>

            <template #cell(tax)="data">
                <p class="text-right">
                    {{ calculateItemTax(data.item) | currency }}
                </p>
            </template>

            <template #cell(total)="data">
                <p class="text-right">
                    {{ calculateItemCost(data.item) | currency }}
                </p>
            </template>

            <template #cell(task_checked)="data">
                {{ data.value == 1 ? 'Yes' : 'No' }}
            </template>

            <!--   <template #bottom-row="{ fields, columns }">
                <b-td v-for="(field, i) in fields" :key="i">
                    {{ i }} {{ columns }}
                </b-td>
            </template> -->
        </b-table>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'display-order-items',
    data: () => ({
        type: null,
        isAssignment: true,
    }),
    mixins: [popupMixins],
    filters: {
        displayTypeName(id, itemTypes) {
            return (itemTypes.find(x => x.id == id) || {}).name
        },

        displayWarehouseSection(id, sections) {
            return (sections.find(x => x.id == id) || {}).name
        },

        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
    },
    computed: {
        warehouse_sections() {
            return this.$store.getters['locations/warehouse_sections']
        },
        orderItems() {
            return this.$store.state.orders.orderItems
        },
        itemTypes() {
            return this.$store.state.itemType.items
        },
        assets() {
            return this.$store.state.assets.assets
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },

        options() {
            return [
                { text: 'Assignment', value: true },
                { text: 'Check-Off', value: false },
            ]
        },
        fields() {
            const _fields = [
                { key: 'id', label: '', stickyColumn: true },
                { key: 'index', label: 'No' },
                { key: 'name', label: 'Name' },
                { key: 'order_item_type_id', label: 'Type' },
            ]
            const assignmentFields = [
                { key: 'details', label: 'Details' },
                { key: 'quantity', label: 'Qty' },
                { key: 'price', label: 'Price' },
                { key: 'total', label: 'Total' },
                { key: 'tax', label: 'Tax' },
            ]

            const checkOffFields = [
                { key: 'task_checked', label: 'Checked' },
                { key: 'task_value', label: 'Value' },
                { key: 'task_notes', label: 'Notes' },
            ]

            _fields.push(
                ...(this.isAssignment ? assignmentFields : checkOffFields)
            )

            return _fields
        },
    },
    watch: {
        isAssignment: function (val) {
            this.$emit('toggleAssignment', !val)
        },
    },
    mounted() {
        this.$nextTick().then(() => {
            this.$emit('toggleAssignment', !this.isAssignment)
        })
    },
    methods: {
        calculateItemTax(item) {
            const type =
                this.itemTypes.find(x => item.order_item_type_id === x.id) || {}

            let itemCost =
                (type.is_discount ? -1 : 1) *
                (parseFloat(item.price) || 0) *
                (parseFloat(item.quantity) || 1)
            return (itemCost * (parseFloat(item.tax_rate) || 0)) / 100
        },

        deleteItem(id) {
            const order_id = this.$route.params.id
            console.log(order_id)
            console.log(id)
            console.log(this.user_permissions)

            const title = 'Delete Order Item?'
            const message = `Are you sure you want to delete this order Item?`
            this.confirmMessage(title, message).then(result => {
                console.log('result', result)
                if (result) {
                    this.$store
                        .dispatch('orders/deleteOrderItem', { order_id, id })
                        .then(() => {
                            this.doToast(
                                'Deleted!',
                                'Your order item has been deleted.',
                                'success'
                            )
                        })
                        .catch(err => {
                            console.error(err)
                            this.doToast(
                                'Error!',
                                'Unable to delete order item!',
                                'danger'
                            )
                        })
                }
            })
        },

        calculateItemCost(item) {
            const type =
                this.itemTypes.find(x => item.order_item_type_id === x.id) || {}

            return (
                (type.is_discount ? -1 : 1) *
                (parseFloat(item.price) || 0) *
                (parseFloat(item.quantity) || 1)
            )
        },

        displayAssets(ids) {
            // x.name + ' ' + x.serial_no,
            const self = this
            return ids.reduce((_str, id, idx, _list) => {
                const asset = self.assets.find(x => x.id === id) || {}
                if (idx === 0) {
                    _str = `<b>Asset${_list.length ? 's' : ''}:</b> `
                }
                _str += `<br/>${idx + 1}&#58; ${asset.name}-${asset.serial_no}`
                return _str
            }, '')
        },
    },
}
</script>

<style scoped>
ul {
    margin: 0;
}
ul.dashed {
    list-style-type: none;
}
ul.dashed > li {
    text-indent: -30px;
}
ul.dashed > li:before {
    content: '';
    text-indent: -30px;
}
</style>
